export default "__VITE_PUBLIC_ASSET__7f6b87ea__"